import { render, staticRenderFns } from "./RoteirizacaoHistoricoSaveDialog.vue?vue&type=template&id=a0b8479a&"
import script from "./RoteirizacaoHistoricoSaveDialog.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoHistoricoSaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports